<div class="organization-empty-event-list">
  <div class="organization-empty-event-list__icon">
    <app-icon [name]="ICONS.SEARCH_24"></app-icon>

    <img class="organization-empty-event-list__icon-background"
         src="/assets/images/search-icon-background.svg">
  </div>

  <div>
    <h4 class="organization-empty-event-list__title"> {{ 'organization_empty_event_list_title' | t }}</h4>
    <div class="organization-empty-event-list__description"> {{ 'organization_empty_event_list_description' | t }}</div>
  </div>
  <div class="organization-empty-event-list__actions">
    <a [routerLink]="'/' + ROUTES.RESULTS" [queryParams]="queryParams">
      <app-button [buttonStyle]="BUTTON_STYLES.WHITE_OUTLINED">
        {{ 'organization_empty_event_list_view_events' | t }}
      </app-button>
    </a>
    <!--    TODO: enable when contact us form is ready-->
    <!--    <app-button [buttonStyle]="BUTTON_STYLES.ACTION">-->
    <!--      {{ 'organization_empty_event_list_contact_us' | t }}-->
    <!--    </app-button>-->
  </div>
</div>
